import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "./firebase";

import { useSnackbar } from "./SnackbarHandler";
import KeyIcon from "@mui/icons-material/Key";
import PersonIcon from "@mui/icons-material/Person";
import { updateStudentQuiz } from "./quizFunctions";

import SchoolIcon from "@mui/icons-material/School";
import { useTheme } from "@mui/material/styles";
import { getStyles } from "../index";

const StudentEntry = () => {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const styles = getStyles(theme);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  // In StudentEntry.js

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // First, check the quiz collection
      const quizQuery = query(collection(db, "quiz"));
      const querySnapshot = await getDocs(quizQuery);
      const matchingQuiz = querySnapshot.docs.find(
        (doc) => doc.id.substring(0, 6) === code,
      );

      if (matchingQuiz) {
        const quizData = matchingQuiz.data();
        // Add this line to track initial join
        await updateStudentQuiz(matchingQuiz.id, name, [], false);
        sessionStorage.setItem("studentName", name);
        navigate(`/app/quiz/${matchingQuiz.id}/${quizData.quizName}?v=t`);
      } else {
        // If not found in quiz collection, check hpTestData collection
        const hpQuery = query(collection(db, "hpTestData"));
        const hpQuerySnapshot = await getDocs(hpQuery);
        const matchingHpTest = hpQuerySnapshot.docs.find(
          (doc) => doc.id.substring(0, 6) === code,
        );

        if (matchingHpTest) {
          console.log("hittade hp test: ", matchingHpTest.id);

          // If found in hpTestData, navigate to /app/hp/id
          sessionStorage.setItem("studentName", name);
          navigate(`/app/hp/${matchingHpTest.id}?v=t`);
        } else {
          // Not found in either collection
          showSnackbar("Inget prov hittades med denna kod.", "error");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      showSnackbar("Ett fel uppstod.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   try {
  //     const quizQuery = query(collection(db, "quiz"));
  //     const querySnapshot = await getDocs(quizQuery);
  //     const matchingQuiz = querySnapshot.docs.find(
  //       (doc) => doc.id.substring(0, 6) === code,
  //     );
  //     if (matchingQuiz) {
  //       const quizData = matchingQuiz.data();
  //       // Add this line to track initial join
  //       await updateStudentQuiz(matchingQuiz.id, name, [], false);
  //       sessionStorage.setItem("studentName", name);
  //       navigate(`/app/quiz/${matchingQuiz.id}/${quizData.quizName}?v=t`);
  //     } else {
  //       showSnackbar("Ingen quiz hittades med denna kod.", "error");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     showSnackbar("Ett fel uppstod.", "error");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <>
      <Box sx={{ textAlign: "center" }}>
        <SchoolIcon
          sx={{ mb: 1, mt: 12, fontSize: "2rem", color: "text.secondary" }}
        />
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            textAlign: "center",
            mb: 2,
            fontWeight: "600",
            fontSize: "1.4rem",
          }}
        >
          Elever
        </Typography>
      </Box>
      <Box
        sx={{
          ...styles.freshBox,
          maxWidth: 400,
          mx: "auto",

          p: 5,
          textAlign: "center",
        }}
      >
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            placeholder="Kod"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            sx={{ mb: 2 }}
            required
            InputProps={{
              startAdornment: <KeyIcon sx={{ mr: 1 }} />,
            }}
          />

          <TextField
            fullWidth
            placeholder="Ditt namn"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 3 }}
            required
            InputProps={{
              startAdornment: <PersonIcon sx={{ mr: 1 }} />,
            }}
          />

          <Button fullWidth variant="purp" type="submit" disabled={isLoading}>
            {isLoading ? (
              <CircularProgress size={25} sx={{ color: "white" }} />
            ) : (
              "Gå vidare"
            )}
          </Button>
        </form>
      </Box>
    </>
  );
};

export default StudentEntry;
